






















































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Popup, Picker, Toast } from 'vant';
import Uploader from '@/components/next/NewUploader.vue';
import { isWeiXin } from '@/common/ts/common';
import { getAreas, register } from '../api';
Vue.use(Popup)
  .use(Picker)
  .use(Toast);

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component({
  components: {
    Uploader,
  },
})
export default class Register extends Vue {
  name = '';
  school = '';
  county = '';
  grade = '';
  teacher = '';
  recite = '';
  introduction = '';
  cover = [];
  video = [];
  districts = [];
  selectedDistrict = '请选择区县';
  selectedDistrictId = -1;
  showPicker = false;
  isApp = false;
  length = 0;
  retImage = [];
  retVideo = [];
  saveChange = true;
  work_type = '0';
  intonowx: boolean = new Date().getTime() < 1694655379000;
  async mounted() {
    this.isApp = !!window.udid;
    const isLogin = window.gettoken() && window.gettoken() !== 'null';
    const ret = await getAreas();
    this.districts = Object.values(ret.data);
    const unionid = window.localStorage.getItem('unionid');
    if (window.udid && !isLogin) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
      return false;
    } else if (isWeiXin() && !unionid) {
      this.WechatLogin();
    }
    // const nowtime = new Date().getTime();
    // // const endtime = 1695139199000; //'2023-09-19 23:59:59';
    // const endtime = 1694655379000; //'2023-09-14 09:36:19';
    // if (endtime < nowtime) {
    //   this.intonowx = false;
    // }
  }
  clearcatch() {
    this.name = '';
    this.school = '';
    this.grade = '';
    this.selectedDistrict = '请选择区县';
    this.selectedDistrictId = -1;
    this.teacher = '';
    this.recite = '';
    this.introduction = '';
    this.retImage = [];
    this.retVideo = [];
  }
  @Watch('$route.query.id', { immediate: true })
  typechange(newval: any, oldval: any) {
    this.work_type = newval as string;
    this.clearcatch();
  }
  WechatLogin() {
    if (isWeiXin()) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  videoLength(length: number) {
    this.length = length;
  }
  async onSubmit() {
    const res: any = (await (this.$refs
      .imageUploader as Uploader).uploadToOss()) as string[];
    this.retImage = res;
    const ret: any = (await (this.$refs
      .videoUploader as Uploader).uploadToOss()) as string[];
    this.retVideo = ret;

    if (!this.name) {
      Toast('请输入姓名');
      return false;
    } else if (!this.school) {
      Toast('请输入学校');
      return false;
    } else if (this.selectedDistrict === '请选择区县') {
      Toast('请选择区县 ');
      return false;
    } else if (!this.grade) {
      Toast('请输入班级');
      return false;
    } else if (!this.grade) {
      Toast('请输入年纪班级');
      return false;
    } else if (!this.teacher) {
      Toast('请输入指导老师姓名');
      return false;
    } else if (!this.recite) {
      Toast('请输入作品名称');
      return false;
    } else if (!this.introduction) {
      Toast('请填写作品简介');
      return false;
    } else if (this.retImage.length === 0) {
      Toast('请上传封面图');
      return false;
    } else if (this.retVideo.length === 0) {
      Toast('请上传作品视频');
      return false;
    } else {
      this.getSlideData();
    }
  }

  onConfirm(d: string, i: number) {
    this.selectedDistrict = d;
    this.selectedDistrictId = i + 1;
    this.togglePicker();
  }
  onCancel() {
    this.togglePicker();
  }
  togglePicker() {
    this.showPicker = !this.showPicker;
  }
  async getSlideData() {
    if (!this.saveChange) {
      Toast('请勿重复提交！');
      return false;
    }
    this.saveChange = false;
    const data = {
      name: this.name,
      school: this.school,
      class: this.grade,
      county: this.selectedDistrictId,
      teacher: this.teacher,
      recite: this.recite,
      introduction: this.introduction,
      cover: this.retImage.join('|'),
      video: this.retVideo.join('|'),
      work_type: this.work_type,
      unionid: window.localStorage.getItem('unionid'),
      udid: window.udid,
      appkey: window.appkey,
      token: window.gettoken(),
    };
    const retRegister: any = await register(data);
    if (retRegister.code === 200) {
      Toast('作品已进入待审核状态，审核通过后将进入参赛作品列表展示');
      setTimeout(() => {
        this.intonowx = true;
        this.$router.push('home');
      }, 1500);
    } else {
      Toast(retRegister.msg);
      if (retRegister.msg === '身份信息已过期！') {
        localStorage.removeItem('unionid');
        window.location.reload();
      }
    }
  }
}
